import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import MenuHamburger from "../components/MenuHamburger"
import Footer from "../components/Footer";
import { Helmet } from 'react-helmet'

export const ConcertsFI = () => {

    const [showMenuHamburger, setShowMenuHamburger] = useState(true);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [language, setLanguage] = useState("fi");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1023) {
        setShowMenuHamburger(false);
      } else {
        setShowMenuHamburger(true);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
    <Helmet>
      <title>Tatu Kauppinen | Konsertit</title>
      <meta name="description" content="Tulevat konsertit" />
    </Helmet>
    <div className="concert-container">
        {showMenuHamburger && <MenuHamburger isMenuOpen={isMenuOpen} isConcertsPage={true} language={language} />}
        {showMenuHamburger && <MenuHamburger isMenuOpen={isMenuOpen} language={language}/>}
        {!showMenuHamburger && <Header isConcertsPage={true} language={language}/>}
       <div className="calendar-body">
            <div className="concert-upcoming-container">
                <h1 className="concert-heading">Tulossa pian!</h1>
                {/* <h1 className="concert-heading">Tulevat konsertit</h1> */}

            </div>
            {/* <div className="calendar-wrapper">
                <div className="concert-calendar-container">
                    <div className="calendar-image-container">
                        <img className="calendar-image" loading="lazy" src="https://demetrios-antoniades-nextjs-images-api.s3.eu-north-1.amazonaws.com/cello_on.jpg" />
                    </div>
                    <div className="concert-wrapper">
                        <h3 className="concert-name">Karajan Academy ja Seong-Jin Cho</h3>
                        <div className="calendar-date-container">
                            <time className="calendar-date">19/01/2025, klo 20:00</time>
                        </div>
                        <div className="concert-location">
                            <h3 className="concert-place2">Berliinin filharmonian kamarimusiikkisali</h3>
                            <h3 className="concert-place title-margin margin-small">|</h3>
                            <h3 className="concert-place">Berlin, DE</h3>
                        </div>
                        <hr></hr>
                        <div className="players-container">
                            <p>Reinhard Goebel, kapellimestari</p>
                            <p>Karajan Academy</p>
                        </div> 
                        <a target="_blank" className="button-more" href="https://www.berliner-philharmoniker.de/konzerte/kalender/55760/">
                            Lue lisää ohjelmasta täältä
                        </a>
                    </div>
                </div>
            </div>
            <div className="calendar-wrapper last">
                <div className="concert-calendar-container">
                    <div className="calendar-image-container">
                        <img className="calendar-image" loading="lazy" src="https://demetrios-antoniades-nextjs-images-api.s3.eu-north-1.amazonaws.com/cello_on.jpg" />
                    </div>
                    <div className="concert-wrapper">
                        <h3 className="concert-name">Tchaikovsky: Rokokoo-variaatiot op. 33</h3>
                        <div className="calendar-date-container">
                            <time className="calendar-date">FEB 20, 2025 klo 19:00</time>
                        </div>
                        <div className="concert-location">
                            <h3 className="concert-place">Lappeen Marian kirkko</h3>
                            <h3 className="concert-place title-margin margin-small">|</h3>
                            <h3 className="concert-place">Lappeenranta, FI</h3>
                        </div>
                        <hr></hr>
                        <div className="players-container">
                            <p className="margin-bottom">José Maria Moreno, kapellimestari</p>
                            <p className="margin-bottom">Tatu Kauppinen, cello</p>
                            <p>Lappeenrannan kaupunginorkesteri</p>
                        </div>
                        <a target="_blank" className="button-more" href="https://lprorkesteri.fi/fi/Ohjelmisto/Espanjalainen-ilta">
                            Lue lisää ohjelmasta täältä
                        </a>
                    </div>
                </div>
            </div> */}
       </div>
       <Footer/>
    </div>
    </>
  );
};

export default ConcertsFI;
